import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import './styles.css';

const containsTrigger = (list, triggerKey) =>
  !_.isEmpty(
    list.filter(
      element => _.get(element, 'dataset.dropdowntrigger') === triggerKey
    )
  );

/*
  Example usage:
  
    <Dropdown isOpen={isOpen} position={position} onClose={this.closeOptions} triggerKey={key}>
      ...
    </Dropdown>

  Where `isOpen` is boolean and `position` is an object of the type:
  
    {left: 300, top: 200}

  and can easily be obtained by the onclick event:
  
    event.target.getBoundingClientRect()

  and triggerKey should be a unique string which should be set on the trigger of the dropdown like this:

    <div data-dropdowntrigger="unique key" />
*/

class Dropdown extends React.Component<any> {
  closeDropdown = event => {
    if (this.props.isOpen) {
      const path = (event.composedPath && event.composedPath()) || [];

      if (!containsTrigger(path, this.props.triggerKey)) {
        this.props.onClose(event);
      }
    }
  };

  componentDidMount() {
    window.addEventListener('click', this.closeDropdown);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.closeDropdown);
  }

  render() {
    const {
      position,
      isOpen,
      className,
      triggerKey,
      appendToBody = false
    } = this.props;
    let top = 0;
    let left = 0;

    if (appendToBody) {
      top = _.get(position, 'top', 0);
      left = _.get(position, 'left', 0);
    }

    const dropdownElement = (
      <div
        data-dropdowntrigger={triggerKey}
        className={classNames('Dropdown', className, {active: isOpen})}
        style={{top: top, left: left}}>
        {this.props.children}
      </div>
    );

    if (appendToBody) {
      return ReactDOM.createPortal(dropdownElement, document.body);
    }

    return dropdownElement;
  }
}

export default Dropdown;
